import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { FeatureKey, FeaturePermission } from "@pathwright/graphql-client/src/generated"
import { getFeatureInfo, getFeaturePermissionInfo } from "../utils"
import FeatureBlockUI from "./FeatureBlockUI"

const FeatureBlock = ({
  featureKey = null,
  featurePermission = null,
  to = null,
  description
}: {
  featureKey?: FeatureKey | null
  featurePermission?: FeaturePermission | null
  to?: string | object | null
  description?: string | React.ReactNode
}) => {
  const { t } = useTranslate()
  const featureInfo = getFeatureInfo(featureKey, t)
  const featurePermissionInfo = getFeaturePermissionInfo(
    featureKey,
    featurePermission,
    t
  )

  return (
    <FeatureBlockUI
      featureInfo={featureInfo}
      featurePermissionInfo={featurePermissionInfo}
      to={to}
      description={description}
    />
  )
}

FeatureBlock.displayName = "FeatureBlock"

export default FeatureBlock
